import React, { useContext } from "react";
import DashboardLayout from "../../components/DashboardLayout/DashboardLayout";
import { AuthContext } from "../../context/AuthContext";
import "./Dashboard.css";

const DashboardHome = () => {
  const { user } = useContext(AuthContext);

  const stats = [
    { title: "Total Appointments", count: 12, icon: "📅" },
    { title: "Pending Appointments", count: 3, icon: "⏳" },
    { title: "Completed Consultations", count: 8, icon: "✓" },
    { title: "Average Rating", count: "4.8/5", icon: "⭐" },
  ];

  return (
    <DashboardLayout>
      <div className="dashboard-home">
        <div className="welcome-section">
          <h2>Welcome back, {user?.name}!</h2>
          <p>Here's an overview of your recent activity.</p>
        </div>

        {/* Stats Cards */}
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-content">
                <h3>{stat.count}</h3>
                <p>{stat.title}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Recent Activity */}
        <div className="activity-section">
          <h3>Recent Activity</h3>
          <div className="activity-list">
            <div className="activity-item">
              <div className="activity-badge">📋</div>
              <div className="activity-details">
                <p className="activity-title">Appointment Scheduled</p>
                <p className="activity-time">2 hours ago</p>
              </div>
            </div>
            <div className="activity-item">
              <div className="activity-badge">💬</div>
              <div className="activity-details">
                <p className="activity-title">New Message from Dr. Abhinav</p>
                <p className="activity-time">Yesterday</p>
              </div>
            </div>
            <div className="activity-item">
              <div className="activity-badge">✓</div>
              <div className="activity-details">
                <p className="activity-title">Consultation Completed</p>
                <p className="activity-time">3 days ago</p>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="quick-actions">
          <h3>Quick Actions</h3>
          <div className="actions-grid">
            <button className="action-btn">Book Appointment</button>
            <button className="action-btn">Contact Doctor</button>
            <button className="action-btn">View Prescriptions</button>
            <button className="action-btn">Download Reports</button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default DashboardHome;
